module.exports = __webpack_public_path__ + "static/freiraum2-5f61bd34d0eb0654426a5186046106fd.png";